import React from 'react';

import * as styles from './SettingsSection.module.css';

export function SettingsSection({title, description, children}) {
  return (
    <div className={styles.Container}>
      <div className={styles.Info}>
        <h4 className={styles.Title}>{title}</h4>
        <p className={styles.Description}>{description}</p>
      </div>

      <div className={styles.Content}>
        {children}
      </div>
    </div>
  )
}
